import { IState, IPage } from "./state";
import { ActionTree, Store, ActionContext } from 'vuex';

type PayloadType = 'initApp' | 'setState' | 'setPageOpen' | 'togglePage'
export type ActionPayload<ActionData> = {
	type: PayloadType,
	payload: ActionData
}

type ActionHandler<ActionData> = (this: Store<IState>, injectee: ActionContext<IState, IState>, payload: ActionPayload<ActionData>) => any;
type ActionCreator<ActionData> = (data: ActionData) => ActionPayload<ActionData>;

export const togglePage: ActionCreator<IPage> = (page) => ({
	type: 'togglePage',
	payload: page
})

// Action creators
export const initApp: ActionCreator<IState> = (state) => ({
	type: 'initApp',
	payload: state
})

// Action handlers
const initAppAction: ActionHandler<IState> = ({ commit }, { payload }) => {
	commit({
		type: 'setState',
		payload
	})
}

const togglePageAction: ActionHandler<IPage> = ({ state, getters, commit }, { payload }) => {
	const openPage = getters.openPage;
	if(openPage) {
		// Pressed different pages
		if(payload.id !== openPage.id){
			commit({
				type: 'setPageOpen',
				payload: {
					id: openPage.id,
					open: false
				}
			})
			commit({	
				type: 'setPageOpen',
				payload: {
					id: payload.id,
					open: true
				}
			})
		} else if(!state.config.minimenu || window.innerWidth <= 768) {
			commit({
				type: 'setPageOpen',
				payload: {
					id: openPage.id,
					open: false
				}
			})
		}
	} else {
		commit({	
			type: 'setPageOpen',
			payload: {
				id: payload.id,
				open: true
			}
		})
	}
}

const actions: ActionTree<IState, IState> = {
	initApp: initAppAction,
	togglePage: togglePageAction
}

export default actions;
